module.exports = __webpack_public_path__ + "img/fig06.21758354.jpg";